import { UPDATE, SET_MODE } from "./constants";

export const updateMap = payload => {
  return {
    type: UPDATE,
    payload
  };
};

export const setMode = mode => {
  return {
    type: SET_MODE,
    payload: { mode }
  };
};



// WEBPACK FOOTER //
// ./src/app/map/actions.js